class BikeSelector {
	constructor(formId, translations) {
		this.form = document.querySelector(`form#${formId}`);
		if (!this.form) return;

		this.selectors = {
			vendor: this.form.querySelector("#vendor"),
			model: this.form.querySelector("#model"),
			year: this.form.querySelector("#year"),
			button: this.form.querySelector("button"),
			clear: this.form.querySelector("a.clear"),
		};
      this.translations = {
        brand: "Brand",
        bikeModel: "Bike model",
        yearModel: "Year model",
        chooseModel: "Choose model...",
        chooseYear: "Choose year...",
        loading: "Loading...",
        
        ...translations
      }

		this.addStyles();
		this.init();
	}

	addStyles() {
		const styles = `
			form#${this.form.id} {
				display: grid;
				grid-template-columns: ${
					this.form.classList.contains("bike-selector--compact")
						? "1fr 1fr 1fr 1fr"
						: "2fr 2fr 2fr 1fr"
				};
				gap: 3em;
				width: 100%;
			}
			@media screen and (max-width: 768px) {
				form#${this.form.id} {
					grid-template-columns: unset;
					grid-template-rows: repeat(4, auto);
					gap: 1em;
				}
				form#${this.form.id}.bike-selector--compact {
					gap: 0;
				}
				form#${
					this.form.id
				}.bike-selector--compact div:has(select[data-hidden="false"]) {
					margin: 1em 0;
				}
				form#${
					this.form.id
				}.bike-selector--compact div:has(select[data-hidden="true"]), 
				form#${this.form.id} a.clear[data-hidden="true"] {
					display: none;
				}
				
			}

			form#${this.form.id} label {
				display: flex;
				align-items: center;
                
			}

			form#${this.form.id} label:first-of-type {
				font-weight: 600;
			}

			form#${this.form.id} div {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}
			form#${this.form.id} div:has(label) {
				align-items: flex-start;
			}

			form#${this.form.id} select {
				width: 100%;
				appearance: none;
				outline: none;
				background-image: url('data:image/svg+xml,<svg class="icon icon-chevron-down icon-xs absolute pointer-events-none" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M6 9L12 15L18 9"></path></svg>');
				background-size: 2rem;
				background-repeat: no-repeat;
				background-position: calc(100% - 1em) center;
				height: auto;
            
				font-weight: 600;
				padding: clamp(var(--sp-4d5), 1.2vw, var(--sp-5d5)) clamp(var(--sp-6d5), 1.473vw, var(--sp-7d5));
				border-radius: var(--buttons-radius);
				border: var(--inputs-border-width) solid rgb(var(--color-foreground) / var(--border-opacity));
			}

			

			form#${this.form.id}.bike-selector--compact select:invalid:has(option:enabled) {
				color: var(--color-foreground);
			}

			form#${this.form.id} select:focus {
				box-shadow: 0 0 0pt 2pt black;
			}

			form#${this.form.id} select:invalid {
				font-weight: 400;
				color: rgb(var(--color-foreground) / 0.5);
                
			}
            form#${this.form.id} select:has(option:disabled:only-of-type) {
                    pointer-events: none;
            }

			form#${this.form.id} button {
				background: rgb(var(--color-button-background));
				width: 100%;
				outline: none;
				font-weight: 600;
			}

			form#${this.form.id} button:disabled {
				font-weight: 400;
			}
            menu-drawer nav {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }
		`;

		const styleSheet = document.createElement("style");
		styleSheet.textContent = styles;
		document.head.appendChild(styleSheet);
	}

	init() {
		// Initialize selects
		this.flushModel();
		this.flushYear();

		// Bind events
		this.selectors.vendor.addEventListener("change", (e) =>
			this.handleVendorChange(e.target.selectedOptions[0])
		);
		this.selectors.model.addEventListener("change", (e) =>
			this.handleModelChange(e.target.selectedOptions[0])
		);
		this.selectors.year.addEventListener("change", () =>
			this.handleYearChange()
		);
		if (this.selectors.button) {
			this.selectors.button.addEventListener("click", () =>
				this.handleSubmit()
			);
		}
		if (this.selectors.clear) {
			this.selectors.clear.addEventListener("click", () => this.resetForm());
		}
	}

	async fetchVendorData(vendorHandle) {
		try {
			const response = await fetch(
				`https://www.motoproworks.com/pages/vendor/${vendorHandle}`
			);
			const data = await response.json();
			return data.models || [];
		} catch (error) {
			console.error("Error fetching vendor data:", error);
			return [];
		}
	}

	handleVendorChange(selectedOption) {
		this.flushModel();
		this.flushYear();

		const modelSelect = this.selectors.model;
		modelSelect.dataset.loading = true;
		modelSelect.dataset.hidden = false;
		this.selectors.vendor.dataset.hidden = true;
		if (this.selectors.clear) {
			this.selectors.clear.dataset.hidden = false;
		}
		modelSelect.querySelector("option:disabled").innerText = this.translations.loading;

		this.fetchVendorData(selectedOption.dataset.handle)
			.then((models) => {
				this.vendorModels = models; // Store models for later use
				return this.createNodeFromModels(models);
			})
			.then(() => {
				modelSelect.dataset.loading = false;
				modelSelect.querySelector("option:disabled").innerText =
					this.translations.chooseModel;
				setTimeout(() => {
					modelSelect.focus();
				}, this.delay);
			})
			.catch((error) => console.log(error));
	}

	handleModelChange(selectedOption) {
		this.flushYear();
		const yearSelect = this.selectors.year;

		yearSelect.querySelector("option:disabled").innerText = this.translations.loading;
		yearSelect.dataset.hidden = false;
		this.selectors.model.dataset.hidden = true;

		// Find the selected model in our stored data
		const selectedModel = this.vendorModels.find(
			(model) => model.handle === selectedOption.dataset.handle
		);

		if (selectedModel && selectedModel.years) {
			this.createNodesFromYears(new Set(selectedModel.years));
			yearSelect.dataset.loading = false;
			yearSelect.querySelector("option:disabled").innerText = this.translations.chooseYear;
			setTimeout(() => {
				yearSelect.focus();
              console.log(this.delay)
			}, this.delay * 2);
		}
	}

	handleYearChange() {
		this.updateActionValue();
		if (this.form.classList.contains("bike-selector--compact")) {
			console.log("compact");
			this.handleSubmit();
		}
	}

	handleSubmit() {
		window.location.href = this.form.action;
	}

	resetForm() {
		// Reset all selectors to their initial state
		this.selectors.vendor.value = "";
		this.flushModel();
		this.flushYear();

		// Reset data attributes
		this.selectors.model.dataset.hidden = true;
		this.selectors.year.dataset.hidden = true;
		this.selectors.vendor.dataset.hidden = false;

		// Reset form action and button state
		this.form.action = "";
		if (this.selectors.button) {
			this.selectors.button.disabled = true;
		}

		// Focus on vendor selector
		this.selectors.vendor.focus();
	}

	updateActionValue() {
		const modelHandle =
			this.selectors.model.querySelector("option:checked")?.dataset.handle;
		const yearValue =
			this.selectors.year.querySelector("option:checked")?.value;

		if (modelHandle && yearValue) {
			this.form.action = `/collections/${modelHandle}?q=${yearValue}`;
			if (this.selectors.button) {
				this.selectors.button.disabled = false;
			}
		} else {
			if (this.selectors.button) {
				this.selectors.button.disabled = true;
			}
			this.form.action = "";
			setTimeout(() => {
				this.form.querySelector("select:invalid")?.focus();
              
			}, this.delay);
		}
	}

	filterOutYears(product) {
		return product.tags.filter(Number);
	}

	createNodesFromYears(years) {
		const yearSelect = this.selectors.year;
		yearSelect.disabled = false;

		[...years]
			.sort(this.sortYears)
			.reverse()
			.forEach((year) => {
				const element = document.createElement("option");
				element.innerText = year;
				yearSelect.appendChild(element);
			});
	}

	createNodeFromModels(models) {
		models.sort(this.sortModels);
		const modelSelect = this.selectors.model;
		//console.log(models, "models");
		models.forEach((model) => {
			const element = document.createElement("option");
			element.innerText = model.title;
			element.dataset.handle = model.handle;
			modelSelect.appendChild(element);
		});
	}

	flushYear() {
		this.selectors.year.innerHTML =
			'<option value="" disabled selected>'+this.translations.yearModel+'</option>';
	}

	flushModel() {
		this.selectors.model.innerHTML =
			'<option value="" disabled selected>'+this.translations.bikeModel+'</option>';
	}

	sortModels(a, b) {
		// Split titles into parts
		const partsA = a.title.match(/([^\d]+)|(\d+)/g);
		const partsB = b.title.match(/([^\d]+)|(\d+)/g);

		// Compare each part
		for (let i = 0; i < Math.min(partsA.length, partsB.length); i++) {
			// Convert to numbers if both parts are numeric
			const numA = Number(partsA[i]);
			const numB = Number(partsB[i]);
			if (!isNaN(numA) && !isNaN(numB)) {
				if (numA !== numB) return numA - numB;
			} else {
				// Compare as strings
				const comp = partsA[i].localeCompare(partsB[i]);
				if (comp !== 0) return comp;
			}
		}
		// If all parts match up to this point, shorter string comes first
		return partsA.length - partsB.length;
	}
	sortYears(a, b) {
		return a - b;
	}
	mobileAndTabletCheck = function () {
		let check = false;
		(function (a) {
			if (
				/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
					a
				) ||
				/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
					a.substr(0, 4)
				)
			)
				check = true;
		})(navigator.userAgent || navigator.vendor || window.opera);
		return check;
	};
	delay = this.mobileAndTabletCheck() ? 500 : 1;
}
